<script setup>
import {toRefs} from 'vue'

//Emits and props
const emit = defineEmits([
  'click',
])
const props = defineProps({
  isHeader: {
    type: Boolean,
    default: false,
  },
  isClickable: {
    type: Boolean,
    default: false,
  },
})

//Get refs
const {isClickable} = toRefs(props)

//Handle click event
const handleClick = event => {
  if (isClickable.value) {
    emit('click', event)
  }
}
</script>

<template>
  <tr
    :class="{
      [$style.row]: true,
      [$style.header]: isHeader,
      [$style.clickable]: isClickable,
    }"
    :tabindex="isClickable ? 0 : -1"
    :role="isClickable ? 'button' : undefined"
    @click="handleClick($event)"
    @keydown.enter.prevent="handleClick($event)"
    @keydown.space.prevent="handleClick($event)"
  >
    <slot />
  </tr>
  <tr
    v-if="$slots.expandedContent"
    :class="$style.expandedRow"
  >
    <td :colspan="100">
      <div :class="$style.expandedContent">
        <slot name="expandedContent" />
      </div>
    </td>
  </tr>
</template>

<style module lang="scss">
.row {
  background-color: transparent;
  transition: background-color ease-in-out .2s;
  color: inherit;
  &:hover {
    background-color: var(--bg-panels);
  }
  &.clickable {
    cursor: pointer;
    border-radius: var(--border-radius-s);
    &:focus-visible {
      outline: var(--focus-outline);
    }
  }
}
.expandedRow {
  background-color: var(--bg-panels);
}
.expandedContent {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
</style>
